<template>
  <v-card variant="outlined" :class="{ 'border-primary': isPrimary }" min-width="280">
    <v-card-text class="pa-4">
      <div class="d-flex align-center ga-2 mb-2">
        <span class="text-subtitle-1 font-weight-bold"> {{ fullName }} </span>
        <div class="d-flex flex-column ga-1">
          <v-chip v-if="isPrimary" size="small" color="primary" variant="tonal">Primary</v-chip>
          <v-chip v-if="showChartType && patient.extraData?.chartType" size="small" variant="tonal">{{
            patient.extraData.chartType
          }}</v-chip>
        </div>
        <v-spacer />
        <v-btn v-if="editable" icon="mdi-pencil-outline" size="small" variant="text" @click="$emit('edit', patient)" />
        <v-btn v-if="editable" icon="mdi-close" size="small" variant="text" @click="$emit('remove', patient.id)" />
      </div>
      <div class="text-body-2 text-medium-emphasis">
        <div v-if="showExternalId && patient.externalId">MRN: {{ patient.externalId }}</div>
        <div v-if="patient.dob || patient.dobStr">DOB: {{ formatDob(patient) }}</div>
        <div v-if="patient.phoneNumber">Phone: {{ patient.phoneNumber }}</div>
        <div v-if="patient.address">Address: {{ patient.address }}</div>
        <div v-if="showStatus && patient.extraData?.status">Status: {{ patient.extraData.status }}</div>
        <div v-if="showTeam && patient.extraData?.team">Team: {{ patient.extraData.team }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { computed } from "vue";
import { convertDateToMMDDYYYY } from "@/utils";

const props = defineProps({
  patient: {
    type: Object,
    required: true,
  },
  isPrimary: {
    type: Boolean,
    default: false,
  },
  editable: {
    type: Boolean,
    default: false,
  },
  showStatus: {
    type: Boolean,
    default: false,
  },
  showExternalId: {
    type: Boolean,
    default: true,
  },
  showChartType: {
    type: Boolean,
    default: false,
  },
  showTeam: {
    type: Boolean,
    default: false,
  },
});

const fullName = computed(() => {
  const parts = [
    props.patient.firstName,
    props.patient.middleName,
    props.patient.lastName,
    props.patient.suffix,
  ].filter(Boolean);
  return parts.join(" ");
});

const formatDob = (p) => {
  // dobStr is the raw string from the API; dob may be a parsed date object (from Patient model)
  const dateValue = p.dobStr ?? p.dob;
  if (!dateValue) return "";
  if (typeof dateValue === "string") return convertDateToMMDDYYYY(dateValue);
  // If it's a Date object, format manually
  const d = new Date(dateValue);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

defineEmits(["edit", "remove"]);
</script>
